import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Component, Injector, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TableColumn } from '@models/tableColumn';
import '@angular/localize/init';
import { TableOptions } from '@models/tableOptions';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastService } from '@services/toast/toast.service';
import { Customer } from '@models/customer';
import { Operator } from '@models/operator';
import { Blackbox } from '@models/blackbox';
import { plainToClass } from 'class-transformer';
import { BlackboxService } from '@services/entity/blackbox.service';

@Component({
  selector: 'app-blackboxes-table',
  templateUrl: './blackboxes-table.component.html',
  styleUrls: ['./blackboxes-table.component.scss']
})
export class BlackboxesTableComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {
  public className = 'BlackboxesTableComponent';

  @ViewChild('operatorView') operatorView: TemplateRef<any>;
  public isOperatorView: boolean;
  public operator: Operator;
  
  public isUser: boolean = false;
  public isCustomer: boolean = false;
  public isOperator: boolean = false;

  public entities: Blackbox[] = []
  public entitiesAvailable: Blackbox[] = []
  public blackboxCustomersAvailable: Customer[] = []

  private sortParam: number;

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@BlackboxesTableColumn2:Seriennummer`, property: 'serialNumber' },
    { columnDescription: $localize`:@@BlackboxesTableColumn2:Kunde`, property: 'customer.name' },
    { columnDescription: $localize`:@@BlackboxesTableColumn5:PLZ`, property: 'address.postalCode' },
    { columnDescription: $localize`:@@BlackboxesTableColumn5:Ort`, property: 'address.city' },
    { columnDescription: $localize`:@@BlackboxesTableColumn4:Straße`, property: 'address.street' },
    { columnDescription: $localize`:@@BlackboxesTableColumn4:Hausnummer`, property: 'address.houseNumber' },
  ];

  public tableOptions: TableOptions = { hideActions: true, rowRouterLink: 'setup/{serialNumber}' };

  constructor(
    public toastService: ToastService,
    public sanitizer: DomSanitizer,
    public blackboxesService: BlackboxService,
    injector: Injector
  ) {
    super(blackboxesService, injector);
  }

  ngOnInit(): void {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];

    if (!this.isOperatorView) return;
    
    this.activatedRoute.queryParams.subscribe(params => {
      this.sortParam = params.sort;
    });
    
    super.ngOnInit();

    if (!this.sortParam) {
      this.tableFunctions.sortColumn = 'serialNumber';
      this.tableFunctions.sortDirection = 'desc';
    }
  }

  async initializeEntities() {
    this.blackboxesService.getAll().subscribe(result => {
      this.entities = plainToClass(Blackbox, result);
      this.entitiesAvailable = this.entities.filter(bb => bb.customer == null)
      super.setupTable();
      this.tableReady = true
    })
  }
  
  onSort() {
    if (this.sortParam) {
      this.sortParam = undefined;
      this.router.navigate([], {
        queryParams: {
          'sort': null,
        },
        queryParamsHandling: 'merge'
      })
    }
  }

  matches(entity: any, term: any) {
    throw new Error('Method not implemented.');
  }
}
